import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import AppsList from '../AppsList'
import { CallToAction } from '../CallToAction'
import { heading, section } from './classes'

const Listing = ({ name, image, url }) => {
    return (
        <li className="border-t border-l border-dashed border-gray-accent-light">
            <a href={url} className="flex flex-col items-center text-center px-2 py-6 hover:bg-gray-accent-light">
                <img className="icon w-8 h-8 mb-2" src={image} />
                <span className="text-primary">{name}</span>
            </a>
        </li>
    )
}

export default function Apps({ allHomeApps, googleImages })  {
    const { title,  img, subtitle,hideBuildYourOwn, style='',enable } = allHomeApps
       if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    let cta = allHomeApps?.cta
    if (Array.isArray(cta) && cta.length == 1) cta = cta[0]
    const googleImage =
        img &&
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == img) return image
        })[0]
    const googleImage2 =
        img &&
        googleImages &&
        googleImages[1] &&
        googleImages[1].filter((image) => {
            if (image.name == img) return image
        })[0]
    const gatsbyImage = googleImage && getImage(googleImage)
    const gatsbyImage2 = googleImage2 && getImage(googleImage2)
       // const images = withArtDirection(gatsbyImage, [
    //   {
    //     media: "(max-width: 508px)",
    //     image: gatsbyImage2,
    //   },
    // ]);
    const { apps } = useStaticQuery(query)
    return (
        <section className={section('mt-4 md:mt-8')}>
            <h2 className={heading('lg')}
            dangerouslySetInnerHTML={{ __html: title }}>
            </h2>
            {/* <p className="my-6 mx-auto text-center text-lg md:text-lg font-semibold mt-2 lg:mt-4 text-primary max-w-2xl opacity-75">
                Or <a href="/docs/marketplace">build your own app</a>
            </p> */}
            <div className="mt-8 md:mt-12">
                <AppsList hideBuildYourOwn apps={apps?.nodes} />

                <footer className="text-center">
                    <CallToAction to= {cta?.url} type="outline" className="mt-8">
                        {cta?.text}
                    </CallToAction>
                </footer>
            </div>
        </section>
    )
}

const query = graphql`
    query {
        apps: allMdx(
            filter: {
                fields: { slug: { regex: "/^/marketplace/(?!.*/docs).*/" } }
                frontmatter: {
                    title: {
                        in: [
                            "Rightnow Connector"
                            "Zapier Connector"
                            "Salesforce Connector"
                            "Hubspot Connector"
                            "Intercom Connector"
                            "Customer.io Connector"
                            "Segment Connector"
                            "Amazon S3 Export"
                        ]
                    }
                }
            }
            limit: 8
        ) {
            nodes {
                id
                fields {
                    slug
                }
                frontmatter {
                    thumbnail {
                        childImageSharp {
                            gatsbyImageData(placeholder: NONE)
                        }
                    }
                    title
                    badge
                    price
                    pluginType
                    maintainer
                }
            }
        }
    }
`
